var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'OrganizationHome'
      }
    }
  }, [_vm._v(" 組織資料設定 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DailyActivityList'
      }
    }
  }, [_vm._v(_vm._s("每日活動列表") + " ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.isReadOnly ? "查看每日活動" : _vm.isEditing ? "編輯每日活動" : "新增每日活動") + " ")])], 1)], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-6 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" " + _vm._s(_vm.isReadOnly ? "查看每日活動" : _vm.isEditing ? "編輯每日活動" : "新增每日活動") + " ")]), _c('div', {
    staticClass: "col-12 col-xl-8 mt-3"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "通路"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.dailyActivity.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.dailyActivity, "merchant_id", $$v);
      },
      expression: "dailyActivity.merchant_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.dailyActivity.merchant_id.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "會員"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.customers,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.dailyActivity.customer_id,
      callback: function callback($$v) {
        _vm.$set(_vm.dailyActivity, "customer_id", $$v);
      },
      expression: "dailyActivity.customer_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.dailyActivity.merchant_id.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動時間"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "w-50 mr-2"
  }, [_c('datepicker', {
    attrs: {
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.dailyActivity.activity_at,
      callback: function callback($$v) {
        _vm.$set(_vm.dailyActivity, "activity_at", $$v);
      },
      expression: "dailyActivity.activity_at"
    }
  })], 1), _c('div', {
    staticClass: "w-50"
  }, [_c('vue-timepicker', {
    attrs: {
      "format": "HH:mm",
      "input-class": ['form-control'],
      "hide-clear-button": true,
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.activityTime,
      callback: function callback($$v) {
        _vm.activityTime = $$v;
      },
      expression: "activityTime"
    }
  })], 1)]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.dailyActivity.activity_code.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "代碼"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.dailyActivity.activity_code.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.dailyActivity.activity_code,
      callback: function callback($$v) {
        _vm.$set(_vm.dailyActivity, "activity_code", $$v);
      },
      expression: "dailyActivity.activity_code"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.dailyActivity.activity_code.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動值"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.dailyActivity.activity_code.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.dailyActivity.activity_value,
      callback: function callback($$v) {
        _vm.$set(_vm.dailyActivity, "activity_value", $$v);
      },
      expression: "dailyActivity.activity_value"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.dailyActivity.activity_code.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "活動備忘"
    }
  }, [_c('b-form-textarea', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.dailyActivity.activity_memo.$error ? false : null,
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.dailyActivity.activity_memo,
      callback: function callback($$v) {
        _vm.$set(_vm.dailyActivity, "activity_memo", $$v);
      },
      expression: "dailyActivity.activity_memo"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.dailyActivity.activity_memo.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回 ")]), !_vm.isReadOnly ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("儲存")]) : _vm._e()], 1)])], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }